import { useTranslation } from 'react-i18next';

/** Left stage of the auth periphery split: shared watermark + handwritten
 *  note + the page title (moved here from the right column, which carries
 *  only text and controls). The last word gets the coral accent. */
export const AuthStatusStage = ({
	hand,
	title,
}: {
	hand?: string;
	title: string;
}) => {
	const { t } = useTranslation();

	const words = title.trim().split(' ');
	const accent = words.pop();
	const lead = words.join(' ');

	return (
		<div className='stage'>
			<span className='wmk' aria-hidden>
				{t('auth.stage.watermark')}
			</span>
			{hand && <span className='hand'>{hand}</span>}
			<h1 className='big'>
				{lead && <>{lead} </>}
				<em>{accent}</em>
			</h1>
		</div>
	);
};
